export const messages = {
  listenToExpert: {
    id: "lms.listen-to-expert",
  },
};
